import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import EffectUtility from "utilities/EffectUtility";
import NotaEstimateModel from "./models/NotaEstimateModel";
import NoteTopicsModel from "./models/NoteTopicsModel";
import NotaAsRead from "./models/NotaAsRead";

export interface IAddNoteRequest {
    idEstimate?: number;
    text?: string;
    noteType?: number;
    followers?: Array<string>;
}
export interface IGetNoteTopicsRequest {
    pageNumber?: number;
    pageSize?: number;
    sortParam?: string;
    sortAsc?: boolean;
}

export default class NotaEffect {
    public static async getEstimateNote(idEstimate: number): Promise<NotaEstimateModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.estimateNote;
        return EffectUtility.getToModel<NotaEstimateModel>(NotaEstimateModel, endpoint, {
            idEstimate: idEstimate,
        });
    }

    public static async addNota(request: IAddNoteRequest): Promise<NotaEstimateModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.addNote;
        return EffectUtility.postToModel<NotaEstimateModel>(NotaEstimateModel, endpoint, request);
    }

    public static async getNoteTopics(
        request: IGetNoteTopicsRequest
    ): Promise<NoteTopicsModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getTopicNotes;
        return EffectUtility.postToModel<NoteTopicsModel>(NoteTopicsModel, endpoint, request);
    }

    public static async setNoteAsRead(idEstimate: number): Promise<NotaAsRead | HttpErrorResponseModel> {
        const endpoint: string = environment.api.setEstimateNotesAsRead;
        return EffectUtility.postToModel<NotaAsRead>(NotaAsRead, endpoint, {
            idEstimate: idEstimate,
        });
    }
}
